import CrudGenerator from 'admin/pages/shared/CrudGenerator/CrudGenerator';
import ReactJsonViewer from 'app/lib/utils/ReactJsonViewer';
import React from 'react';
import ContentPanel from '../shared/ContentPanel';
import { columns, formSchema, getDurationString } from './ScriptResultsConfig';
import ScriptResultsService from './ScriptResultsService';
import './style.scss';

export default CrudGenerator({
    columns,
    formSchema,
    route: '/admin/script-results',
    entityName: {
        entityNamePlural: "Script Results",
        entityNameSingular: "Script Result"
    },
    getEntities: ScriptResultsService.getScriptResults,
    editEntity: ScriptResultsService.editScriptResults,
    deleteEntities: ScriptResultsService.deleteScriptResults,
    defaultShowAddEditExpandButton: true,
    modalDetails: ({ scriptRunId, scriptName, startedAt, finishedAt, parameters, result }) => {
        return (
            <div>
                <ContentPanel dividerOrientation="left" title="Script Info">
                    <table className="script-result-details-table" border={1}>
                        <tr>
                            <td className="td-bold">Script ID:</td>
                            <td>{scriptRunId}</td>
                            <td className="td-bold">Script Name:</td>
                            <td>{scriptName}</td>
                        </tr>
                        <tr>
                            <td className="td-bold">Run At:</td>
                            <td>{startedAt}</td>
                            <td className="td-bold">Duration:</td>
                            <td>{getDurationString(startedAt, finishedAt)}</td>
                        </tr>
                        <tr>
                            <td className="td-bold">Environment:</td>
                            <td>Production</td>
                            <td className="td-bold">Status:</td>
                            <td>Finished</td>
                        </tr>
                    </table>
                </ContentPanel>
                <ContentPanel dividerOrientation="left" title="Script Response">
                    <table className="script-result-details-table" border={1}>
                        <tr>
                            <td className="td-bold">Perameters:</td>
                            <td className="td-text-aligh-left"><ReactJsonViewer src={parameters} collapsed={true} /></td>
                        </tr>
                        <tr>
                            <td className="td-bold">Results:</td>
                            <td className="td-text-aligh-left"><ReactJsonViewer src={result} height={"600px"} collapsed={true} /></td>
                        </tr>
                    </table>
                </ContentPanel>
            </div>
        )
    }
})